<template>
  <div class="panel-item ">
    <div class="title_name">今日销售数据</div>

    <div class="nowSalesdata_box">

      <div class="left_nums_box">

        <div class="left_box_item">
          <div style="display: flex;">
            <img class="money_img" src="../../../../assets/money.png" alt="">
            <div class="num_txt">有效付款订单数</div>
          </div>
          <div style="display: flex;">
            <div class="num_num">{{ salesdata.current_count_order }}</div>
            <div class="num_txt2">单</div>
          </div>
        </div>


        <div class="left_box_item">
          <div style="display: flex;">
            <img class="money_img" src="../../../../assets/money.png" alt="">
            <div class="num_txt">有效结算订单数</div>
          </div>
          <div style="display: flex;">
            <div class="num_num">{{ salesdata.current_settle_count_order }}</div>
            <div class="num_txt2">单</div>
          </div>
        </div>
        <div class="left_box_item">
          <div style="display: flex;">
            <img class="money_img" src="../../../../assets/money.png" alt="">
            <div class="num_txt">有效付款总金额</div>
          </div>
          <div style="display: flex;">
            <div class="num_num">{{ salesdata.current_sum_pay_amount }}</div>
            <div class="num_txt2">元</div>
          </div>
        </div>
        <div class="left_box_item">
          <div style="display: flex;">
            <img class="money_img" src="../../../../assets/money.png" alt="">
            <div class="num_txt">有效结算总金额</div>
          </div>
          <div style="display: flex;">
            <div class="num_num">{{ salesdata.current_settle_sum_pay_amount }}</div>
            <div class="num_txt2">元</div>
          </div>
        </div>
        <div class="left_box_item">
          <div style="display: flex;">
            <img class="money_img" src="../../../../assets/money.png" alt="">
            <div class="num_txt">有效付款预估服务费</div>
          </div>
          <div style="display: flex;">
            <div class="num_num">{{ salesdata.current_sum_service_amount }}</div>
            <div class="num_txt2">元</div>
          </div>
        </div>
        <div class="left_box_item">
          <div style="display: flex;">
            <img class="money_img" src="../../../../assets/money.png" alt="">
            <div class="num_txt">有效结算服务费</div>
          </div>
          <div style="display: flex;">
            <div class="num_num">{{ salesdata.current_settle_sum_service_amount }}</div>
            <div class="num_txt2">元</div>
          </div>
        </div>


        <div class="left_box_item">
          <div style="display: flex; ">
            <img class="money_img" src="../../../../assets/money.png" alt="">
            <div class="num_txt">申样总数</div>
          </div>
          <div style="display: flex;">
            <div class="num_num">{{ salesdata.current_send_sample_count }}</div>
            <div class="num_txt2">单</div>
          </div>
        </div>
        <div class="left_box_item">
          <div style="display: flex;">
            <img class="money_img" src="../../../../assets/money.png" alt="">
            <div class="num_txt">申样达人数</div>
          </div>
          <div style="display: flex;">
            <div class="num_num">{{ salesdata.current_distinct_talent_num }}</div>
            <div class="num_txt2">个</div>
          </div>
        </div>
      </div>


      <div class="right_nums_box">
        <div class="label">今日GMV</div>
        <div class="gmvLabel">{{ gmvBlock.current_sum_pay_amount }}</div>
        <div class="label">分销者(人)</div>
        <div class="fxzLabel">{{ gmvBlock.fx_user_count }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    salesdata: {
      type: Object,
      default: {}
    },
    gmvBlock: {
      type: Object,
      default: {}
    }
  },
  watch: {
    salesdata(newVal) {
      // console.log('新数据', newVal)
    }
  }
}
</script>

<style lang="scss" scoped>
.panel-item {
  width: 100%;
  height: 310px;
  background: url(../../../../assets/_s-image_sector_bg3.png) no-repeat;
  background-size: 100% 100%;
}

.title_name {
  padding: 32px 0 10px 100px;
  font-weight: 400;
  font-size: 22px;
  color: #FFFFFF;
}

.nowSalesdata_box {
  height: 100%;
  display: flex;
}


.left_nums_box {
  height: calc(100% - 120px);
  display: grid;
  grid-template-columns: repeat(4, 240px);
  align-items: center;
  padding: 0 20px;
  border-right: 1px dashed gray;

  .money_img {
    margin-right: 4px;
    width: 39px;
    height: 23px;
  }

  .num_txt {
    font-weight: 400;
    font-size: 18px;
    color: #F3FFFE;
  }

  .num_num {
    margin-left: 39px;
    font-weight: 600;
    font-size: 28px;
    color: #00A8FF;
  }

  .num_txt2 {
    margin-top: 10px;
    margin-left: 10px;
    font-weight: 400;
    font-size: 16px;
    color: #F3FFFE;
  }
}

.right_nums_box {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  .label {
    font-size: 18px;
    color: white;
  }

  .gmvLabel {
    width: 80%;
    font-size: 36px;
    color: #2ae4f6;
    background: url(../../../../assets/iamge_gmv.png) no-repeat;
    background-size: 100% 100%;
    text-align: center;
  }

  .fxzLabel {
    font-size: 28px;
    color: #00A8FF;

  }
}

</style>